import React, { createContext, useContext, useState } from "react";

export const _locationAlias = "user_location";
export const _shopAlias = "shop_id";
export const _locationEnableAlias = "location_enable";

const MovableContext = createContext(null);

export function MovableProvider({ children }) {
  const [shopId, setShopId] = useState(() => {
    return localStorage.getItem(_shopAlias) || null;
  });

  const [locationEnable, setLocationEnable] = useState(() => {
    return localStorage.getItem(_locationEnableAlias) === "true";
  });

  const [userLocation, setUserLocation] = useState(() => {
    return localStorage.getItem(_locationAlias) || null;  
  });

  const SetShopId = (value) => {
    localStorage.setItem(_shopAlias, value);
    setShopId(value);
  };

  const SetLocationEnable = (value) => {
    localStorage.setItem(_locationEnableAlias, value ? "true" : "false");
    setLocationEnable(value);
  };

  const SetUserLocation = (value) => {
    localStorage.setItem(_locationAlias, value);
    setUserLocation(value);
  };

  const value = {
    shopId,
    locationEnable,
    userLocation,
    SetShopId,
    SetLocationEnable,
    SetUserLocation,
  };

  return (
    <MovableContext.Provider value={value}>
      {children}
    </MovableContext.Provider>
  );
}

export function useMovable() {
  return useContext(MovableContext);
}
